export const skillsData = [
  { name: "Java (Mastered OOP)", level: 95 },
  { name: "JavaFX (Desktop UI)", level: 90 },
  { name: "C++ (Advanced DSA)", level: 90 },
  { name: "JavaScript", level: 80 },
  { name: "Data Structures & Algorithms", level: 85 },
  { name: "Object-Oriented Design", level: 90 },
  { name: "Git & GitHub", level: 85 },
  { name: "Problem Solving", level: 90 },
  { name: "TypeScript", level: 80 },
  { name: "React", level: 85 },
  { name: "Chakra UI", level: 75 },
  { name: "React Query", level: 75 },
  { name: "Zustand", level: 70 },
  { name: "REST APIs & Axios", level: 80 },
];
